<template>
  <div class="container">
    <h2 class="section-title">新闻动态</h2>
    <p class="section-sub">聚焦智慧医疗前沿，传递爱谱乐声音</p>
    <div class="grid-3">
      <div v-for="item in newsList" :key="item.id" class="card" @click="$router.push(item.link)">
        <img :src="item.img" :alt="item.title">
        <div class="card-body">
          <h3>{{ item.title }}</h3>
          <p class="date">{{ item.date }}</p>
          <p>{{ item.summary }}</p>
          <span class="more">阅读全文 →</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      newsList: [
        { id: 1, title: '爱谱乐医疗亮相2025全国手术室学术年会', date: '2025-03-20', summary: '', img: '/img/news/01.png', link: '/news/1' },
        { id: 2, title: '苏州爱谱乐智能医疗科技亮相第38届浙江春季医展会', date: '2025-02-10', summary: '', img: '/img/news/03.png', link: '/news/2' },
        { id: 3, title: '艾隆科技&爱谱乐联肩亮相第93届CMEF春季盛会', date: '2025-01-05', summary: '', img: '/img/news/05.png', link: '/news/3' }
      ]
    };
  }
};
</script>

<style scoped>
.container { max-width: 1280px; margin: 0 auto; padding: 48px 24px; }
.section-title { font-size: 32px; font-weight: 700; text-align: center; margin-bottom: 16px; color: #0f2b36; }
.section-sub { text-align: center; color: #4b5563; max-width: 700px; margin: 0 auto 40px; }
.grid-3 { display: grid; grid-template-columns: repeat(auto-fit, minmax(300px, 1fr)); gap: 32px; }
.card { background: white; border-radius: 24px; overflow: hidden; box-shadow: 0 8px 20px rgba(0,0,0,0.05); cursor: pointer; transition: 0.3s; }
.card:hover { transform: translateY(-5px); }
.card img { width: 100%; height: 200px; object-fit: cover; }
.card-body { padding: 20px; }
.card-body h3 { margin-bottom: 8px; }
.date { color: #888; font-size: 13px; margin: 8px 0; }
.more { color: #1f8aad; font-weight: 500; display: inline-block; margin-top: 12px; }
</style>